/** Structured scoring catalogue + legacy chapter filter for navigation. */
import { projektGajaChapters } from './content';
export {
  projektGajaScoringRecords,
  filterProjektGajaScoring,
  validateProjektGajaScoringTables,
} from './scoringTables';
export type {
  ProjektGajaScoringRecord,
  ProjektGajaModuleId,
} from './scoringTables';

/** Chapters whose titles mention scoring — for chapter-based navigation. */
export const projektGajaScoring = projektGajaChapters.filter((chapter) =>
  /punkt|scor/i.test(chapter.title)
);
